import React from 'react';
import PropTypes from 'prop-types';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import Loadable from 'react-loadable';
import styles from './index.css';
import Artical from './artical';

// import SeriesList from './seriesList';

class LeftContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        const {
            article,
            commentPPX,
            qrcode,
            hardAd,
            articleTopAd,
            contentBottomAd,
            tuanRecommendl,
            curCity,
            seriesInfo,
            carSeriesData,
            txtAd,
        } = content;
        // 佛教无为您推荐内容
        return (
            <div className={styles.leftContent}>
                {carSeriesData && carSeriesData.serialId ? <div className={styles.space20} /> : ''}
                <Artical
                    content={article}
                    articleTopAd={articleTopAd}
                    txtAd={txtAd}
                    commentPPX={commentPPX}
                    qrcode={qrcode}
                    tuanRecommendl={tuanRecommendl}
                    curCity={curCity}
                    seriesInfo={seriesInfo}
                />
                <div className={styles.space30} />
                <div className={styles.space40} />
                <div>
                    <Ad content={hardAd} styleName={styles.hardAd} />
                    <div className={styles.space30} />
                    <Ad content={contentBottomAd} styleName={styles.contentBottomAd} />
                </div>
                <div className={styles.space25} />
                {/* {seriesList ? <SeriesList content={seriesList} /> : ''} */}
            </div>
        );
    }
}

export default errorBoundary(LeftContent);
